module.exports = __webpack_public_path__ + "assets/img/filter.6374c9fb.png";